/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCheckUserSubscriptionModel,
  ICheckUserSubscriptionRequest,
  IMappers,
  ICheckUserSubscriptionResponse,
  ICheckUserSubscriptionResponseError,
  TCheckUserSubscriptionResponse,
} from './types';

const defaultConfig: TCheckUserSubscriptionModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'price-change-notification',
  pathApi: '/v1/check-user-subscription/',
  hostType: 'api',
} as TCheckUserSubscriptionModel;

function createCheckUserSubscriptionModel(parameters: ICheckUserSubscriptionRequest): TCheckUserSubscriptionModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckUserSubscriptionOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckUserSubscriptionRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckUserSubscription<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICheckUserSubscriptionOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCheckUserSubscriptionResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCheckUserSubscriptionModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckUserSubscriptionResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckUserSubscriptionResponseError);
    }
  }

  return { response, statusCode } as TCheckUserSubscriptionResponse;
}

export { defaultConfig, createCheckUserSubscriptionModel, fetchCheckUserSubscription };
